import { render, staticRenderFns } from "./SendView.vue?vue&type=template&id=00fcbf24&scoped=true&"
import script from "./SendView.vue?vue&type=script&lang=js&"
export * from "./SendView.vue?vue&type=script&lang=js&"
import style0 from "./SendView.vue?vue&type=style&index=0&id=00fcbf24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcbf24",
  null
  
)

export default component.exports